import React, { Component } from 'react';

import RSelect from 'react-select';

import 'react-select/dist/react-select.css';
import './select.scss';

export default class Select extends Component {

    render() {
        const {className, children, ...otherProps} = this.props;

        return (
            <div className={`aselect ${className}`}>
                <RSelect {...otherProps}>
                    {children}
                </RSelect>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/select/Select.js